var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg24Img(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 25,
    viewBox: "0 0 27 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 12.5C24 6.14873 18.8513 1 12.5 1C6.14873 1 1 6.14873 1 12.5C1 18.8513 6.14873 24 12.5 24V24C15.7622 24 18.7071 22.6417 20.8001 20.4598",
    stroke: "#AFB0B6",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2305 11.1729L23.9997 12.4998L25.7689 11.1729",
    stroke: "#AFB0B6",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.1441 9.44058C10.586 9.44058 10.9634 9.51906 11.2761 9.67601C11.5889 9.83297 11.8256 10.0432 11.9863 10.3068C12.147 10.5704 12.2274 10.8621 12.2274 11.1819C12.2274 11.4958 12.17 11.789 12.0552 12.0614C11.9404 12.3339 11.7267 12.6537 11.4139 13.0209C11.1011 13.3881 10.6406 13.8472 10.0322 14.398H12.3565L12.1929 15.5974H8.29333V14.4957C8.97627 13.8146 9.47842 13.2949 9.7998 12.9365C10.1212 12.5782 10.345 12.2821 10.4713 12.0481C10.5975 11.8141 10.6606 11.5817 10.6606 11.3507C10.6606 11.1315 10.6004 10.9583 10.4799 10.831C10.3593 10.7036 10.1929 10.64 9.98058 10.64C9.77972 10.64 9.60038 10.6888 9.44256 10.7865C9.28473 10.8843 9.12548 11.0397 8.96479 11.253L8.07812 10.5156C8.3249 10.178 8.62189 9.91441 8.96909 9.72488C9.3163 9.53534 9.70798 9.44058 10.1441 9.44058ZM17.3659 13.1801V14.3528H16.7375V15.5966H15.2396L15.231 14.3528H12.7776V13.3134L14.4046 9.4043L15.7131 9.89293L14.353 13.1801H15.2483L15.4204 11.8119H16.7375V13.1801H17.3659Z",
    fill: "#AFB0B6"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg24Img);
export default __webpack_public_path__ + "static/media/24img.058ad7ad2b336eb6803534f3df8b64bf.svg";
export { ForwardRef as ReactComponent };